module.exports = new __parcel__URL__("analyze.a5a885cc.png").toString();